// src/overlayComponents/ModuleDescription.js
import React from 'react';
import { useTheme } from '../../themes/ThemeProvider';

const ModuleDescription = ({ description }) => {
  const { theme } = useTheme();
  
  if (!description) return null;
  
  return (
    <div className={`${theme.description}`}>
      {description}
    </div>
  );
};

export default ModuleDescription;